"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.File = {
    name: 'ScFileField',
    functional: true,
    props: {
        field: {
            type: Object,
            required: true,
        },
    },
    // Need to assign `any` return type because Vue type definitions are inaccurate.
    // The Vue type definitions set `render` to a return type of VNode and that's it.
    // However, it is possible to return null | string | VNode[] | VNodeChildrenArrayContents.
    render: function (createElement, context) {
        var field = context.props.field;
        /*
        File fields cannot be managed via the EE. We never output "editable."
      */
        if (!field || (!field.value && !field.src)) {
            return null;
        }
        // handle link directly on field for forgetful devs
        var file = field.src ? field : field.value;
        if (!file) {
            return null;
        }
        if (context.data.scopedSlots && context.data.scopedSlots.default) {
            return context.data.scopedSlots.default(file);
        }
        var linkText = file.title || file.displayName;
        // in functional components, context.data should be passed along to the
        // `createElement` function in order to retain attributes and events
        // https://vuejs.org/v2/guide/render-function.html#Passing-Attributes-and-Events-to-Child-Elements-Components
        var data = __assign({}, context.data, { attrs: __assign({}, context.data.attrs, { href: file.src }) });
        return createElement('a', data, linkText);
    },
};
